export const nameError = "Navn må kun indeholde bogstaver, mellemrum eller `.,\'-";
export const emailError = 'Det skal være en gyldig e-mail';
export const companyError =  "Firmanavn kan indeholde bogstaver, tal, mellemrum og @`&#_;+*~!?/.,'-";
export const phoneError = 'Tlf.nr. må kun indeholde tal samt +-().';
export const postalCodeError = "Dette postnummer er ikke gyldigt.";
export const eanError = "EAN skal bestå af 13 cifre";
export const vatIdError = "CVR nummer kan bestå af bogstaver, tal, mellemrum og @`&#_;+*~!?/.,'-";
export const addressError = "Adressen kan bestå af bogstaver, tal, mellemrum og @`&#_;+*~!?/.,'-";
export const cityError = "Byen kan bestå af bogstaver, mellemrum og `.,'-";
export const manySimilarSymbolsError = "Der er for mange ens tegn efter hinanden.";
export const atLeastOneLetterError = "Mindst ét bogstav er påkrævet i dette felt.";

export const atLeastXDigitsError = (x) => `Mindst ${x} tal er påkrævet i detten felt.`;
export const symbolsLimitError = (symbols_limit) => `${symbols_limit} maksimalt antal symboler.`;
export const requiredFieldError = (field) => `${field} skal udfyldes`;
export const minNumberError = (field, min) => `${field} skal være mindst ${min} cifre`;
export const minSymbolsError = (field, min) => `${field} skal være mindst ${min} symboler`;

